import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  paymentMethod: "bank-card",
}

export const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setPaymentMethod: (state,action) => {
      state.paymentMethod = action.payload
    },
  },
})

// Callback func to retrieve the paymentMethod for the useSelector Hook
export const selectPaymentMethod = (state) => {
  return state.payment.paymentMethod;
}

export const { setPaymentMethod} = paymentSlice.actions

export default paymentSlice.reducer